// @flow

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Hidden,
  makeStyles,
  Typography,
} from '@material-ui/core';
import {colors} from '../../../../../../assets/styles/colors';

import CustomButton from '../../../../../../elements/CustomButton/CustomButton';
import type {Theme} from '@material-ui/core';

type Props = {
  setStep: number => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  title: {
    color: colors.grey900,
    fontSize: 16,
    fontWeight: 600,
  },
  subtitle: {
    color: colors.grey700,
    fontSize: 14,
    fontWeight: 400,
  },
  checkboxList: {
    width: '100%',
    margin: theme.spacing(2),
  },
  checkboxLabel: {
    fontSize: 14,
    fontWeight: 400,
    color: colors.grey900,
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
    },
  },
  actionButton: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '15rem',
    },
  },
}));

export default function CreateTable(props: Props) {
  const {setStep} = props;
  const classes = useStyles();

  const [innerStep, setInnerStep] = useState<number>(0);

  const [itemsSelected, setItemsSelected] = useState([]);

  const handleReturnStep = () => {
    if (innerStep === 0) setStep(0);
    else setInnerStep(0);
  };

  const handleContinueStep = () => {
    if (innerStep === 0) {
      setInnerStep(1);
    } else {
      console.log('Save');
    }
  };

  const onCheckboxChange = e => {
    e.persist();
    if (e.target) {
      if (e.target.checked) {
        setItemsSelected(prev => [...prev, e.target.name]);
      } else {
        setItemsSelected(prev => prev.filter(i => i !== e.target.name));
      }
    }
  };

  const checkboxItems = [
    {
      label: 'US',
      orderMobile: 0,
    },
    {
      label: 'Largo de pie (cm)',
      orderMobile: 1,
    },
    {
      label: 'Busto (cm)',
      orderMobile: 6,
    },
    {
      label: 'Cuello (cm)',
      orderMobile: 7,
    },
    {
      label: 'UK',
      orderMobile: 2,
    },
    {
      label: 'Ancho de pie (cm)',
      orderMobile: 3,
    },
    {
      label: 'Pecho (cm)',
      orderMobile: 8,
    },
    {
      label: 'Cintura (cm)',
      orderMobile: 9,
    },
    {
      label: 'EUR',
      orderMobile: 4,
    },
    {
      label: 'Largo Total (cm)',
      orderMobile: 5,
    },
    {
      label: 'Manga (cm)',
      orderMobile: 10,
    },
    {
      label: 'Cadera (cm)',
      orderMobile: 11,
    },
  ];

  return (
    <>
      <div className={classes.root}>
        {innerStep === 0 ? (
          <>
            <Typography className={classes.title}>
              Seleccionar las columnas que aparecerán en tu guía
            </Typography>
            <Typography className={classes.subtitle}>
              Puedes elegir hasta 4
            </Typography>

            <div className={classes.checkboxList}>
              <Hidden mdUp>
                <Grid container spacing={1}>
                  {checkboxItems
                    .sort((a, b) => (a.orderMobile > b.orderMobile ? 1 : -1))
                    .map(c => (
                      <Grid item xs={6}>
                        <FormControlLabel
                          classes={{label: classes.checkboxLabel}}
                          label={c.label}
                          control={
                            <Checkbox
                              name={c.label}
                              color="primary"
                              onChange={onCheckboxChange}
                              checked={itemsSelected.includes(c.label)}
                              disabled={
                                itemsSelected.length >= 4 &&
                                !itemsSelected.includes(c.label)
                              }
                            />
                          }
                        />
                      </Grid>
                    ))}
                </Grid>
              </Hidden>
              <Hidden smDown>
                <Grid container spacing={1}>
                  {checkboxItems.map(c => (
                    <Grid item xs={3}>
                      <FormControlLabel
                        classes={{label: classes.checkboxLabel}}
                        label={c.label}
                        control={
                          <Checkbox
                            name={c.label}
                            color="primary"
                            onChange={onCheckboxChange}
                            checked={itemsSelected.includes(c.label)}
                            disabled={
                              itemsSelected.length >= 4 &&
                              !itemsSelected.includes(c.label)
                            }
                          />
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
              </Hidden>
            </div>
          </>
        ) : (
          <div>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>
                  Completa los datos de tu guía
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>Vista Previa</Typography>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
      <Divider className={classes.divider} style={{margin: '48px 0 16px 0'}} />

      <div
        className={classes.actionButtons}
        // style={{justifyContent: step ? 'space-between' : 'center'}}
      >
        <CustomButton
          className={classes.actionButton}
          variant="outlined"
          onClick={handleReturnStep}
        >
          Anterior
        </CustomButton>

        <CustomButton
          className={classes.actionButton}
          variant="contained"
          onClick={handleContinueStep}
        >
          {innerStep === 0 ? 'Siguiente' : 'Guardar Guía'}
        </CustomButton>
      </div>
    </>
  );
}

CreateTable.propTypes = {
  setStep: PropTypes.func.isRequired,
};
